import Dropdown from 'components/UIKit/Dropdown';
import { ParamsLink } from 'components/Links';

const ErrorTypeFilter = ({
  error_type,
  errorTypes = {},
  query,
  style,
}) => (
  <span style={style}>
    <span>Error Type: &nbsp;</span>
    <Dropdown selected={error_type || 'All'}>
      <ParamsLink
        query={{
          ...query,
          // ...(error_type || {}),
          offset: 0,
        }}
        includeCurrentParams={false}
        >
        All
      </ParamsLink>
      {/* Object.assign(
        [],
        ...errorTypes.general,
        ...errorTypes[entityGroupFinder(entity)]
      )
        .sort((a, b) => a - b) */
      Object.keys(errorTypes)
        .map(type => (
          <ParamsLink
            active={type === error_type}
            key={type}
            query={{
              ...query,
              error_type: type,
              offset: 0,
            }}
            tooltip={errorTypes[type].description}
            includeCurrentParams={false}
            >
            {type}
          </ParamsLink>
        ))
      }
    </Dropdown>
  </span>
);

export default ErrorTypeFilter;
